import { Modal, Spin } from 'antd';
import React from 'react';
import DynamicZenChart from '../../pages/DynamicZenChart';
import { LoadingOutlined } from '@ant-design/icons';
import DtWidget from '../dt/Widget';


const DTModal = ({ modal, toggleModal }) => {
    console.log(modal);
    const widgetModal = modal.typ === 'widget' && (
        <DtWidget data={modal.data} />
    );

    const dynamicZenChartModal = modal.typ === 'dynamicZenChart' && (
        <DynamicZenChart api={modal.api || '/dt/compliance'} urlData={{ ...modal.data }} />
    )

    return (
        <Modal maskClosable={false} direction={'ltr'} width={"65%"} title="Line Status" className='digital-twin-modal' onCancel={toggleModal} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} open={modal.open}>
            {
                modal.loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 70, color: '#ffffff' }} />} />
                    </div> :
                    <div>
                        {widgetModal}
                        {dynamicZenChartModal}
                    </div>
            }

        </Modal>
    )
};

export default DTModal;